// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

priceStyles.productPrice = {
    price: {
        priceText: {
            size: 22,
            lineHeight: "22px",
        },
        unitOfMeasureText: {
            size: 22,
            lineHeight: "22px",
        },
    },
};

(priceStyles.productPrice.price || ({} as any)).nonStockText = {
    size: fontConfig.fontSize.xSmall,
    weight: fontConfig.weight.semiBold,
    css: css`
        display: block;
        color: ${getColor("danger.main")};
    `,
    ellipsis: true,
};
